// extracted by mini-css-extract-plugin
module.exports = {"upNextOverlay":"_3jrwFZ2VEtUFhARkF4kawd","upNextContainer":"_2zQ444oP4MePb0B9aJlDUW","upNextTimer":"_1UUojUxcSIbwoXJanIUA5x","videoCard":"ulkmEFESegZznFfhwcF3e"};